import { render, staticRenderFns } from "./quotationAdd.vue?vue&type=template&id=0fa9c1bc&scoped=true"
import script from "./quotationAdd.vue?vue&type=script&lang=js"
export * from "./quotationAdd.vue?vue&type=script&lang=js"
import style0 from "./quotationAdd.vue?vue&type=style&index=0&id=0fa9c1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9c1bc",
  null
  
)

export default component.exports